import { render, staticRenderFns } from "./riskAppConf.vue?vue&type=template&id=dccaf572&scoped=true"
import script from "./riskAppConf.vue?vue&type=script&lang=js"
export * from "./riskAppConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccaf572",
  null
  
)

export default component.exports